export function replaceTemplateBlocksInString(str, textBlocks) {
  let output = str;

  for (const { key, value } of textBlocks) {
    // Replace ALL occurrences of the key
    const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape regex chars
    output = output.replace(new RegExp(escaped, 'g'), value);
  }

  return output;
}
